<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">Inventario físico de productos</h2>
    <MainPhysicalInventory />
  </div>
</template>

<script>
import MainPhysicalInventory from "@/components/Reports/Products/PhysicalInventory/MainPhysicalInventory.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "PhysicalInventory",
  components: {
    MainPhysicalInventory,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
